var _defs, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonZoomOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 156 156",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #001213;\n        stroke-width: 7px;\n      }\n\n      .st0, .st1 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .st2 {\n        fill: #f1f1f2;\n      }\n\n      .st1 {\n        stroke: #010101;\n        stroke-width: 5px;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 78,
    cy: 78,
    r: 77
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 71.1,
    cy: 71.1,
    r: 23.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 88.6,
    y1: 88.6,
    x2: 106.8,
    y2: 106.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 80.2,
    y1: 71.1,
    x2: 71.3,
    y2: 71.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 62.3,
    y1: 71.1,
    x2: 71.3,
    y2: 71.1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonZoomOut);
export default __webpack_public_path__ + "static/media/button_zoom_out.0d3e23899809813f53030189b3164c01.svg";
export { ForwardRef as ReactComponent };